import mixpanel from 'mixpanel-browser';

class MixpanelSingleton {
  constructor() {
    if (process.env.MIX_ANALYTICS_ENABLED === 'true') {
      mixpanel.init(process.env.MIX_PANEL_TOKEN, {
        debug: process.env.MIX_PANEL_DEBUG === 'true',
        api_host: process.env.MIX_PANEL_PROXY_DOMAIN,
      });
    }
  }

  identify(id) {
    if (process.env.MIX_ANALYTICS_ENABLED === 'true') {
      mixpanel.identify(id);
    }
  }

  setUserOnce(properties) {
    if (process.env.MIX_ANALYTICS_ENABLED === 'true') {
      mixpanel.people.set_once(properties);
    }
  }

  setUser(properties) {
    if (process.env.MIX_ANALYTICS_ENABLED === 'true') {
      mixpanel.people.set(properties);
    }
  }

  reset() {
    if (process.env.MIX_ANALYTICS_ENABLED === 'true') {
      mixpanel.reset();
    }
  }

  track(name, options = {}) {
    if (process.env.MIX_ANALYTICS_ENABLED === 'true') {
      mixpanel.track(name, options);
    }
  }
}

const MixpanelInstance = Object.freeze(new MixpanelSingleton());

export default MixpanelInstance;
